<template>
    <form v-if="status.detail" @submit.prevent="submitForm">
        <b-form-group :label="$t('label.name')" label-cols="3" label-align="left">
            <b-form-input v-model.trim="form.name" :state="fieldState" />
            <b-form-invalid-feedback>{{ $t('message.requiredX', [$t('label.name')]) }}</b-form-invalid-feedback>
        </b-form-group>

        <hr class="my-3 mx-n3">
        <div class="d-flex justify-content-end">
            <b-button type="button" variant="danger" class="mr-2" @click="$emit('done')">
                {{ $t('label.cancel') }}
            </b-button>
            <b-button type="submit" variant="info" :disabled="!status.save">
                <span v-if="status.save">
                    {{ $t(categoryUUID ? 'label.updateX' : 'label.createX', [$t('module.articleCategory')]) }}
                </span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center p-5">
        <b-spinner variant="info" />
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { articleCategoryMethods } from '@/state/api';
import { ARTICLE_CATEGORY_MODULE } from '@/state/api/articleCategory.state';

export default {
    name: 'ArticleCategoryForm',
    props: {
        categoryUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true },
    },
    data() {
        return { submitted: false, form: { uuid: '', name: '' } };
    },
    validations: { form: { name: { required } } },
    computed: {
        ...mapState(ARTICLE_CATEGORY_MODULE, ['status']),
        details() {
            return this.$store.state.api.articleCategory.details || {};
        },
        fieldState() {
            return this.submitted ? !this.$v.form.name.$invalid : null;
        },
    },
    created() {
        this.loadCategory();
    },
    methods: {
        ...articleCategoryMethods,
        async loadCategory() {
            if (!this.categoryUUID) return;
            const result = await this.getArticleCategory({ uuid: this.categoryUUID });
            if (result) this.form = { ...this.form, ...this.details };
        },
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) return;
            const action = this.categoryUUID ? this.updateArticleCategory : this.createArticleCategory;
            const result = await action({ data: this.form, filter: this.searchCriteria });
            if (result?.success) this.$emit('done');
        },
    },
};
</script>
